import axios from "../axios-auth";

export const creditLevelService = {
    getCreditLevels,
    saveCreditLevel,
    getCreditLevelDetail
};

function getCreditLevels(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams) {
        if (searchParams.name) {
            params["name"] = searchParams.name;
        }
    }

    return axios.get("/auth/credit-levels", { params });
}

function saveCreditLevel(creditLevel) {
    if (!creditLevel.id) {
        // new credit level
        return axios.post("/auth/credit-level", creditLevel);
    } else {
        // edit
        return axios.put("/auth/credit-level", creditLevel);
    }
}

function getCreditLevelDetail(id) {
    return axios.get("/auth/credit-level/" + id);
}

